import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export interface ImageUniDriver extends BaseUniDriver {
  isTransparent: () => Promise<boolean>;
}

export const imageDriverFactory = (base: UniDriver): ImageUniDriver => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether background of Image is transparent
     * @return {Promise<boolean>}
     */
    isTransparent: async () => (await base.attr('data-transparent')) === 'true',
  };
};
